module.exports = __webpack_public_path__ + "img/star_like.af4dab84.png";